import { z } from "zod";

/** Highest ordinal on the scale — the ungraded N/A rung. */
export const SCALE_ORDINAL_MAX = 6;

/**
 * Payload for editing one rung of the global scale (Settings → Config →
 * Performance ratings): the rating name plus the scale-wide definition shown on
 * hover wherever ratings appear. A blank definition clears it.
 */
export const levelNameSchema = z.object({
  ordinal: z.number().int().min(1).max(SCALE_ORDINAL_MAX),
  name: z.string().trim().min(1, "Name is required").max(200),
  description: z.string().trim().max(2000).nullable(),
});
export type LevelNameInput = z.infer<typeof levelNameSchema>;

/**
 * Payload for the two visibility checkboxes: whether a rung appears in the app
 * UI (Person Profile rating control, role expectation grid) and whether it is
 * offered on the feedback survey.
 *
 * Separate from the rename payload so toggling a box doesn't have to round-trip
 * the name and definition — which would let a checkbox silently overwrite
 * someone else's concurrent rename. Both flags are optional; sending neither is
 * a no-op rather than an error.
 */
export const levelVisibilitySchema = z.object({
  ordinal: z.number().int().min(1).max(SCALE_ORDINAL_MAX),
  showInApp: z.boolean().optional(),
  showOnFeedback: z.boolean().optional(),
});
export type LevelVisibilityInput = z.infer<typeof levelVisibilitySchema>;
